const Clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export default Clamp;
